module.exports = __webpack_public_path__ + "img/Beach_Vater_Tochter1.a00b68a2.png";